export class UserRoles {
  constructor(
    readonly userId: string,
    readonly roles: string[],
  ) {}
}
